import { txt } from "../../services/translation";
import countries from "../../config/countries.json";
import { InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const defaultCountryCode = 'FR';

export default function Phone({value, onChange, country, required, error, disableCountry, hideCountry}){

    const [countryData, setCountryData] = useState(null)

    useEffect(() => {

        let data = countries.find(c => c.code === country) 
            || countries.find(c => c.code === defaultCountryCode);
        
        setCountryData(data)

    }, [country])


    const handleCountryChange = e => {

        onChange('', e.target.value)
    }

    const handleNumberChange = e => {

        let num = cleanNumber(e.target.value);

        let phone = countryData.dial + num;

        onChange(phone, countryData.code)
    }
    
    return countryData && 
    
        <Stack direction='row' alignItems='center' spacing={1}>

            {!hideCountry &&

                <TextField
                    select
                    label={txt('country')}
                    size='small'
                    required
                    sx={{flex: 1}}
                    disabled={disableCountry ? true : false}
                    value={countryData.code || defaultCountryCode}
                    onChange={handleCountryChange}
                >
                    {countries.map(c => 
                        <MenuItem value={c.code} key={c.code}>
                            {c.name} ({c.dial})
                        </MenuItem>
                    )}
                </TextField>
            }

            <TextField
                size='small'
                label={txt('phone')}
                required={required}
                inputProps={{
                    minLength: required ? 6 : 0,
                    maxLength: 15
                }}
                InputProps={{
                    startAdornment: <InputAdornment position="start">{countryData.dial}</InputAdornment>,
                }}
                sx={{flex: 1}}
                value={cleanNumber(value, countryData.dial)}
                onChange={handleNumberChange}
                helperText={error || ''}
            />


        </Stack>
}


function cleanNumber(phone, dial){

    return (phone || '')
        .replaceAll(dial, '')
        .replaceAll('+', '')
        .replace(/^0+/, '')
        .replace(/[^0-9]/g, '')
        .substring(0, 15)
}